export default class LLMReplyCollector {
      waitingForFirstToken = true;
      wipMsgMoved = false;
      llmRunning = false;

      isReadyToMoveWipMessage() {
            return !this.llmRunning && !this.wipMsgMoved
      }

      wipMoved() {
            this.wipMsgMoved = true;
      }

      updateWipMesage(newMsgPart: string): string | ((msg: string) => string) {
            this.wipMsgMoved = false;
            if (this.waitingForFirstToken) {
                  this.waitingForFirstToken = false;
                  return newMsgPart;
            } else {
                  return (msg) => msg + newMsgPart;
            }
      }

      replyFinished(): ((msg: string) => string) {
            this.llmRunning = false;
            this.waitingForFirstToken = true;

            // hack
            return (msg) => msg + '\n'
      }
}